import { HrCommonAuthority } from './hr-common-authority';
import { combineAuth } from './hr-authority';

export class OrganizationAuthority extends HrCommonAuthority {

    public static readonly MY_BASE = "organization";

    constructor(authority: string) {
        super(combineAuth(OrganizationAuthority.MY_BASE, authority));
    }

}
